import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
var ViewJobComponent = /** @class */ (function () {
    function ViewJobComponent(dashboardService, errorHandlerService, router, route) {
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.route = route;
        this.job = {};
        this.user = {};
        this.query = '';
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
    }
    ViewJobComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    ViewJobComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.query = params['jobId'] || 0;
            if (_this.query != '0') {
                _this.dashboardService.getJob(_this.query).subscribe(function (data) {
                    console.log(data);
                    _this.job = data;
                    _this.user = data.userDetailsSummary;
                }, function (error) {
                    _this.handleError(error);
                });
            }
        });
    };
    ViewJobComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return ViewJobComponent;
}());
export { ViewJobComponent };
//# sourceMappingURL=viewjob.component.js.map